
<div class="loader-container" id="loader" *ngIf="!evento">
    <div class="loader"></div>
</div>
<div *ngIf="evento">
    <div class="main-banner-cont ">
        <div class="row align-items-center text-center" style="width: 100%;">
            <div class="col-lg-4"><img src="assets/img/uefa-logo.png"></div>
            <div class="col-lg-4"><h1 style="color: #FFF">TICKETVERLOSUNG</h1></div>
            <div class="col-lg-4"><button [disabled]="loadingParticipant" (click)="getParticipants()" class="unstyled-button"><img src="assets/img/uefa-button-header.png"></button></div>
        </div> 
        <div class="row mt-5 align-items-center text-center" style="width: 100%;">
            <div class="col-lg-6 participants">
                <div *ngIf="participants.length > 0 && !loadingParticipant" style="height: 330px; overflow-y: scroll; width: 480px; margin: auto;">
                    <p *ngFor="let participant of participants">{{participant}}</p>
                </div>
            </div>
            <div class="col-lg-6 winner">
                <div class="countdown" *ngIf="countdown > 0">
                    <p>{{countdown}}</p>
                </div>
                <div class="box-winner" *ngIf="winner">
                    <h2>Herzlichen Glückwunsch!</h2>
                    <p style="font-weight: bold;">{{winner.nombre }}</p>
                    <p>{{winner.email}}</p>
                    <img src="/assets/img/uefa-winner.png" />
                </div>
            </div>
        </div>
        <div class="row  mt-3 align-items-center text-center" style="width: 100%;">
            <div class="col-lg-6">
                <button [disabled]="loadingWinner" (click)="sortear()" class="unstyled-button"><img src="assets/img/uefa-button-draw.png"></button>
            </div>
        </div>
        <div class="footer-background" style="width: 100%;"></div>
    </div>
</div>
